import * as React from "react";
import { BrandItem, BrandItemData } from './brand-item';
import { genBlock } from "@/utils/bem";
import "./style.less";

interface ScrollBrandProps {
  brandList: BrandItemData[]
}

const block = genBlock("wx-scroll-brand");

export const ScrollBrand: React.FC<ScrollBrandProps> = ({
  brandList = []
}) => {
  const scrollWrapRef = React.useRef<HTMLDivElement>();
  const [wrapRect, setWrapRect] = React.useState<DOMRect>();

  React.useEffect(() => {
    setWrapRect(scrollWrapRef.current.getBoundingClientRect());
  }, []);

  return (
    <div className={block()}>
      <div className={block("other")}>
        <div className={block("other-title")}>快站其他产品服务</div>
        <div className={block("other-desc")}>
          快站不仅拥有完善的公众号管理系统
          <br />
          还能够搭建网站、小程序、收集表单、发起投票
          <br />
          以及快速生成短链，帮助用户实现互联网高效运营。
        </div>
      </div>
      <div className={block("scroll-wrap")} ref={scrollWrapRef}>
        {brandList.map((item) => (
          <BrandItem {...item} wrapRect={wrapRect} />
        ))}
      </div>
    </div>
  );
};
